import { Button, styled } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { BiSolidFilePlus } from 'react-icons/bi';
import { CgSpinner } from 'react-icons/cg';
import { toast } from 'react-toastify';

import api from '../../services/apiSgft';
import LightTooltip from '../atoms/LightTooltip';

const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});

export const CreateTrainingControlHistoryUploadButton = () => {
	const [loading, setLoading] = React.useState(false);
	const queryClient = useQueryClient();

	const upload = async (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files) {
			const file = event.target.files[0];
			const formData = new FormData();
			formData.append('file', file);

			try {
				setLoading(true);
				await api.post(
					'training-control/training-control-history/create-by-upload',
					formData,
				);
				toast.success(
					'Upload de histórico de treinamentos realizado com sucesso!',
					{
						theme: 'colored',
						toastId: 'success',
					},
				);
				queryClient.invalidateQueries({
					queryKey: ['training-control'],
				});
				queryClient.invalidateQueries({
					queryKey: ['employee-trainings'],
				});
			} catch (error: any) {
				toast.error(
					error?.response?.data?.message ??
						'Erro ao fazer upload de treinamentos!',
					{
						theme: 'colored',
						toastId: 'error',
						autoClose: false,
						style: {
							whiteSpace: 'pre-wrap',
						},
					},
				);
			} finally {
				setLoading(false);
			}
		}
	};

	return (
		<LightTooltip title="Criar históricos de treinamentos">
			{loading ? (
				<CgSpinner size={30} color="#c1c1c1" className="h-full animate-spin" />
			) : (
				<Button
					sx={{
						backgroundColor: 'inherit',
						height: '2.7rem',
						width: '2.7rem',
						padding: '8px',
						minWidth: 0,
						borderRadius: '50%',
						'&:hover': {
							backgroundColor: '#EAEDF4 !important',
						},
					}}
					component="label"
				>
					<BiSolidFilePlus color="grey" fontSize={'1.7rem'} />
					<VisuallyHiddenInput
						type="file"
						onChange={(e) => upload(e)}
						accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					/>
				</Button>
			)}
		</LightTooltip>
	);
};
